import { createContext } from "react";
import { Meta } from "../../types/Meta";

export const MetaContext = createContext({} as Meta);
